var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-menu-footer has-padding has-text-centered"},[_c('div',{staticClass:"poweredBy has-padding-top has-text-centered has-text-grey is-size-7"},[_c('img',{attrs:{"src":require("@/assets/images/cyberdigma.png"),"alt":"Cyberdigma logo","width":"20","height":"20"}}),_c('span',[_vm._v("Powered by Cyberdigma")])])])
}]

export { render, staticRenderFns }